import { graphql } from 'react-relay';
import { genericMutation, useGenericMutation } from '../utils';
import type { Auth_LoginWithProvider_Mutation } from './__generated__/Auth_LoginWithProvider_Mutation.graphql';
import type { Auth_Logout_Mutation } from './__generated__/Auth_Logout_Mutation.graphql';
import type { Auth_PasswordReset_Mutation } from './__generated__/Auth_PasswordReset_Mutation.graphql';
import type { Auth_ResetUserPassword_Mutation } from './__generated__/Auth_ResetUserPassword_Mutation.graphql';

export type {
  Auth_LoginWithProvider_Mutation,
  Auth_LoginWithProvider_Mutation$data,
  Auth_LoginWithProvider_Mutation$variables,
} from './__generated__/Auth_LoginWithProvider_Mutation.graphql';

export const LoginWithProviders = graphql`
  mutation Auth_LoginWithProvider_Mutation($input: LoginInput!) {
    login(input: $input) {
      authToken
      authTokenExpiration
      refreshToken
      refreshTokenExpiration
      user {
        ...User_Fragment @relay(mask: false)
      }
    }
  }
`;

export const loginWithProvidersMutation = genericMutation<Auth_LoginWithProvider_Mutation>({
  mutation: LoginWithProviders,
});

export const useLoginWithProvidersMutation =
  useGenericMutation<Auth_LoginWithProvider_Mutation>(loginWithProvidersMutation);

const LogoutMutation = graphql`
  mutation Auth_Logout_Mutation($input: LogoutInput!) {
    logout(input: $input) {
      success
    }
  }
`;
export type { Auth_Logout_Mutation } from './__generated__/Auth_Logout_Mutation.graphql';
export const logoutMutation = genericMutation<Auth_Logout_Mutation>({
  mutation: LogoutMutation,
});

const PasswordResetMutation = graphql`
  mutation Auth_PasswordReset_Mutation($input: ZnSendPasswordResetEmailInput!) {
    znSendPasswordResetEmail(input: $input) {
      clientMutationId
    }
  }
`;

export type { Auth_PasswordReset_Mutation } from './__generated__/Auth_PasswordReset_Mutation.graphql';
export const passwordResetMutation = genericMutation<Auth_PasswordReset_Mutation>({
  mutation: PasswordResetMutation,
});

export * from './__generated__/Auth_ResetUserPassword_Mutation.graphql';
const ResetUserPasswordMutation = graphql`
  mutation Auth_ResetUserPassword_Mutation($input: ResetUserPasswordInput!) {
    resetUserPassword(input: $input) {
      clientMutationId
      user {
        ...User_Fragment @relay(mask: false)
      }
    }
  }
`;

export const resetUserPasswordMutation = genericMutation<Auth_ResetUserPassword_Mutation>({
  mutation: ResetUserPasswordMutation,
});
